// extracted by mini-css-extract-plugin
module.exports = {"block":"styles_block__35cDV"};